"use strict";
var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
Object.defineProperty(exports, "__esModule", { value: true });
exports.Table = void 0;
const jsx_runtime_1 = require("react/jsx-runtime");
const styled_1 = __importDefault(require("@emotion/styled"));
const Body_1 = require("./Body");
const Cell_1 = require("./Cell");
const GroupHeader_1 = require("./GroupHeader");
const Head_1 = require("./Head");
const HeadCell_1 = require("./HeadCell");
const Row_1 = require("./Row");
const useTableProps_1 = require("./useTableProps");
const constants_1 = require("../../constants");
const TablePropsContextProvider = (props) => {
    return ((0, jsx_runtime_1.jsx)(useTableProps_1.TablePropsContext.Provider, { value: props, children: props.children }));
};
const TableElement = styled_1.default.table((props) => ({
    borderCollapse: 'collapse',
    lineHeight: 'inherit',
    tableLayout: props.fixed ? 'fixed' : undefined,
    width: '100%',
    'td, th': {
        borderBottom: props.bordered ? `1px solid ${constants_1.Color.MEDIUM_GREY}` : undefined,
    },
}));
const TableRoot = styled_1.default.div((props) => ({
    backgroundColor: constants_1.Color.WHITE,
    border: props.borderless ? undefined : constants_1.theme.border.style.thin,
    borderRadius: props.borderless ? undefined : constants_1.theme.border.radius.normal,
    boxShadow: props.borderless ? 'none' : constants_1.theme.boxShadow.normal,
    flexGrow: 1,
    overflowX: props.overflowable ? undefined : 'auto',
    ...(props.overflowable && {
        overflowY: 'auto',
        height: 0,
    }),
}));
const Table = (props) => {
    return ((0, jsx_runtime_1.jsx)(TablePropsContextProvider, { ...props, children: (0, jsx_runtime_1.jsx)(TableRoot, { overflowable: props.overflowable, borderless: props.borderless, children: (0, jsx_runtime_1.jsx)(TableElement, { bordered: props.bordered, fixed: props.fixed, children: props.children }) }) }));
};
exports.Table = Table;
Table.Body = Body_1.TableBody;
Table.Cell = Cell_1.TableCell;
Table.Head = Head_1.TableHead;
Table.HeadCell = HeadCell_1.TableHeadCell;
Table.Row = Row_1.TableRow;
Table.GroupHeader = GroupHeader_1.TableGroupHeader;
